import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationServices } from '../../../../appauth/notification/notificatio.services';
import { CustomValidators } from 'ng2-validation';
import { Periodos } from '../../periodo/periodos.model';
import { PeriodosServices } from '../../periodo/periodos.services';
import { SPINNER, NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
	selector: 'app-addperiodo',
	templateUrl: './addperiodo.component.html',
	styleUrls: ['./addperiodo.component.scss']
})

export class AddPeriodoComponent implements OnInit {
	public formAddPeriodo: FormGroup;
	agregar:boolean=false;
	inconoLoder:string=SPINNER.wanderingCubes;

	constructor(private fb: FormBuilder,
		private activeModal:NgbActiveModal,
		private ngxService: NgxUiLoaderService,
		private servicioPeriodo:PeriodosServices,
		private Noti:NotificationServices,) { }

	ngOnInit() {
		this.ngxService.startLoader('loaderAddPeriodo');
		this.servicioPeriodo.viewSubPeriodoActivo({}).subscribe((datasub:any)=>{
			if(datasub.periodo){
				if(datasub.periodo.subperiodos.length===0){
					this.servicioPeriodo.viewPeriodoActivo().subscribe((data:any)=>{
						console.log(data.periodo);
						if(!data.periodo ){
							this.agregar=true;
							this.ngxService.stopLoader('loaderAddPeriodo');
							
						}else{
							this.ngxService.stopLoader('loaderAddPeriodo');
						}
					});
				}else{
					this.ngxService.stopLoader('loaderAddPeriodo');
				}
			}else{
				this.servicioPeriodo.viewPeriodoActivo().subscribe((data:any)=>{
					if(!data.periodo ){
						this.agregar=true;
						this.ngxService.stopLoader('loaderAddPeriodo');
						
					}else{
						this.ngxService.stopLoader('loaderAddPeriodo');
					}
				});
			}
			
		});
		this.formAddPeriodo = this.fb.group({
			nombre:[null,Validators.compose([Validators.required,Validators.minLength(1), Validators.maxLength(200)])],
			fechainicio:[null,Validators.compose([Validators.required,CustomValidators.date])],
			fechafin:[null,Validators.compose([Validators.required,CustomValidators.date])],
			estado:[1,null],
		});
	}


	save(){
		let periodoDataModel:Periodos=this.formAddPeriodo.value;
		this.servicioPeriodo.savePeriodos(periodoDataModel).subscribe((data:any)=>{
			if(data.estado){
				this.Noti.setNotification(data).then((datas)=>{
					if(datas){
						this.activeModal.close(1);
					}
				});
			}else{
				this.Noti.setNotification(data);
			}
		});
	}

	cerrarModal(){
		this.activeModal.close(2);
	}
}